import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import authReducer from './reducers/authReducer';
import taskListReducer from './reducers/taskListReducer';
import taskDetailReducer from './reducers/taskDetailReducer';
import { createSocketMiddleware } from '../utils/socket';
import baseApi from '../api/baseApi';

const reducer = {
  auth: authReducer,
  taskList: taskListReducer,
  taskDetail: taskDetailReducer,
  [baseApi.reducerPath]: baseApi.reducer
};
const preloadedState = {};
const middleware = [thunk, createSocketMiddleware(), baseApi.middleware];

const store = configureStore({ reducer, preloadedState, middleware });

export default store;
